import React, {useEffect, useState} from 'react';
import {Box, Fade, Modal, Typography, CircularProgress} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CloseIcon from "@mui/icons-material/Close";

import Smile from "./Smile";

import {style} from "../helpers/style";


function Emotions({open, setOpen}) {
    let [max,setMax] = useState('')
    useEffect(() => {
        if(!open?.emotion || !open?.emotion?.emotions || Object.keys(open?.emotion?.emotions).length === 0) {
            setMax('')
            return
        }
        const maxEmotion = Object.keys(open?.emotion?.emotions).reduce((a, b) => (open?.emotion?.emotions[a] > open?.emotion?.emotions[b] ? a : b));
        setMax(maxEmotion)
    }, [open])
    useEffect(() => {
       console.log(open);
       
    }, [open])

    // Helper function to render transcription content
    const renderTranscription = () => {
        // Handle nested data structure: open.data.data or open.data
        const data = open?.data?.data || open?.data;
        
        // Check if processing
        if (data?.status === 'processing') {
            return (
                <div style={{textAlign: 'center', padding: '20px'}}>
                    <CircularProgress size={40} />
                    <p style={{marginTop: '10px'}}>Processing transcription... Please wait.</p>
                </div>
            );
        }

        // Check if we have segments (array format from wav.am)
        if (data?.segments && Array.isArray(data.segments) && data.segments.length > 0) {
            return (
                <div>
                    {data.segments.map((segment, index) => (
                        <div key={index} style={{marginBottom: '15px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
                            {segment.speaker !== undefined && segment.speaker !== null && (
                                <strong style={{color: '#0973b9', display: 'block', marginBottom: '5px'}}>
                                    Speaker {segment.speaker}:
                                </strong>
                            )}
                            <p style={{margin: 0}}>{segment.text || ''}</p>
                        </div>
                    ))}
                </div>
            );
        }

        // Check if we have text
        if (data?.text) {
            return <p>{data.text}</p>;
        }

        // Fallback to old format
        if (open?.data?.transcription) {
            return <p>{open.data.transcription}</p>;
        }

        return <p>No transcription available.</p>;
    }

    // Determine modal title
    const getModalTitle = () => {
        if (open?.emotion?.summary || (open?.emotion?.emotions && Object.keys(open.emotion.emotions).length > 0)) {
            return 'Emotions';
        }
        const data = open?.data?.data || open?.data;
        if (data && (data.text || data.segments || data.status)) {
            return 'Transcription';
        }
        return 'Emotions';
    }

    return (
        <>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={!!open}
                onClose={() => {
                    setOpen({})
                }}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={!!open}>
                    <Box sx={style}>
                        <div className="d-flex flex-row justify-content-between">
                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                {getModalTitle()}
                            </Typography>
                            <span style={{cursor: 'pointer'}} onClick={() => setOpen({})}>
                                <CloseIcon/>
                            </span>
                        </div>

                        {open.emotion?.summary?<div style={{margin: '20px 0'}}
                             className="d-flex flex-row align-items-center justify-content-between">
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile size={max === 'happy'?'58':'40'} color={max === 'happy'?'#4ab847':'#222222'} icon="happy"/>
                                <span>{Math.round(open?.emotion?.emotions?.happy || 0)} %</span>
                            </p>
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile icon="sad" size={max === 'sad'?'58':'40'} color={max === 'sad'?'#1a61af':'#222222'}/>
                                <span>{Math.round(open?.emotion?.emotions?.sad || 0)} %</span>

                            </p>
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile size={max === 'neutral'?'60':'41'} icon="neutral" color={max === 'neutral'?'#aaaaaa':'#222222'}/>
                                <span>{Math.round(open?.emotion?.emotions?.neutral || 0)} %</span>
                            </p>
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile icon="angry" color={max === 'angry'?'#e71e24':'#222222'} size={max === 'angry'?'60':'41'}/>
                                <span>{Math.round(open?.emotion?.emotions?.angry || 0)} %</span>
                            </p>
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile icon="surprised" color={max === 'surprise'?'#fbe925':'#222222'} size={max === 'surprise'?'60':'41'}/>
                                <span>{Math.round(open?.emotion?.emotions?.surprise||0)} %</span>
                            </p>
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile icon="scared" color={max === 'fear'?'#f6911f':'#222222'} size={max === 'fear'?'58':'40'}/>
                                <span>{Math.round(open?.emotion?.emotions?.fear||0)} %</span>
                            </p>
                            <p className="d-flex flex-column justify-content-center align-items-center">
                                <Smile icon="disgust" color={max === 'disgust'?'#612d91':'#222222'} size={max === 'disgust'?'58':'40'}/>
                                <span>{Math.round(open?.emotion?.emotions?.disgust||0)} %</span>
                            </p>
                        </div>:null}
                        <div id="transition-modal-description sip_content" className="test_mode">
                            {open.emotion?.summary ? (
                                <p dangerouslySetInnerHTML={{__html: open.emotion?.summary}}/>
                            ) : (
                                renderTranscription()
                            )}
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}

export default Emotions;